<template>
    <v-timeline dense clipped>
    <v-timeline-item v-for="item in logs"
                     class="mb-3"
                     :color="types[item.Type].color"
                     icon-color="grey lighten-2"
                     small
    >
        <v-layout justify-space-between>
            <v-flex xs8><h5> {{types[item.Type].title}}</h5>
             {{item.Text}}


              <br>
                <strong>{{getIp(item)}}</strong>
                <br>
              <v-card v-if="item.Type === 'order' && getNotes(item)!==''">
                <v-card-text> {{getNotes(item)}}</v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs2 text-xs-right>{{item.AddedAt | moment("DD/MM - HH:mm:ss")}}</v-flex>
            <v-flex xs2 text-xs-right>
            <v-btn :to="'customer/'+item.CustomerID">
                Πελάτης
            </v-btn>
            </v-flex>
        </v-layout>
    </v-timeline-item>
    </v-timeline>
</template>

<script>
    export default {
        name: "log-items",
        props:{logs:Array},
        data:()=>({
            types: {
                'login': {color: 'blue', title: "Άνοιγμα Προσφοράς"},
                'order': {color: 'green', title: "Εκτέλεση Παραγγελίας"}
            }
        }),
        methods: {
            getIp(item) {
                return JSON.parse(item.Value).ip;
            },
            getNotes(item){
              return JSON.parse(item.Value).Notes;
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/LogItems.vue